import styled from 'styled-components';
import { Title as DefaultTitle } from '~components';

export const Title = styled(DefaultTitle)`
  margin-top: 76px;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-top: ${({ theme }) => theme.spacing.km10};
  }
`;
